const error403 = {
  name: 'Erro 403',
  title: 'Ops! Acesso negado.',
  subtitle: 'Somente pessoas autorizadas podem acessar esta página.',
};

export default error403;
